module.exports = __webpack_public_path__ + "img/子岸镇.e52b5035.png";